import { useState, useEffect } from 'react';
const MESSAGE_TYPE = 'embeddedConfluenceVisibleHeight';

export const useIframeVisibleHeight = (
	uniqueKey?: string,
): {
	visibleHeight: number;
} => {
	// The initial height is arbitrarily set to 1000
	const [visibleHeight, setVisibleHeight] = useState(1000);

	useEffect(() => {
		const contentSizeHandler = (postMessage: MessageEvent) => {
			const data = postMessage.data;

			if (
				data?.type === MESSAGE_TYPE &&
				data?.value &&
				// If uniqueKey is provided, check if the message is for the correct uniqueKey; if uniqueKey is undefined, fallback to existing logic to accept all messages
				(uniqueKey ? data?.uniqueKey === uniqueKey : true)
			) {
				setVisibleHeight(data.value);
			}
		};

		window.addEventListener('message', contentSizeHandler);

		return () => {
			window.removeEventListener('message', contentSizeHandler);
		};
	}, [uniqueKey]);

	return { visibleHeight };
};
